module.exports = __webpack_public_path__ + "static/media/forecasting-systems-4.76f2048a.jpg";